<div class="lv-login-box">
  <div class="lv-login-box__header"></div>
  <div class="lv-login-box__content">
    <div class="lv-login-box__title" translate>password-reset-request-sent.title</div>
    <div class="success-message" translate>password-reset-request-sent.success-message</div>
    <div class="message" translate>password-reset-request-sent.description</div>
    <a routerLink="/auth/sign_in" class="button" translate>password-reset-request-sent.button</a>
  </div>
</div>

<lv-copyright></lv-copyright>
